import documentTypes from 'constants/documentTypes';
import { Document, Society } from 'types';

type FilterDocumentsPerSectionProps = {
  sectionTag: string;
  documents: Document[];
  updateLoadingData: (value: boolean) => void; // eslint-disable-line
  actualSociety: Society;
  isAdmin: boolean;
  currentBook: Document;
  currentCouncilMinute: Document;
  currentFolder: any;
  signatureDocumentCategory: string;
};

export const filterDocumentsPerSection = ({
  sectionTag,
  documents,
  updateLoadingData,
  actualSociety,
  isAdmin,
  currentBook,
  currentCouncilMinute,
  signatureDocumentCategory,
  currentFolder,
}: FilterDocumentsPerSectionProps) => {
  if (!sectionTag || !documents.length) return;

  let docs = [];
  updateLoadingData(false);

  switch (sectionTag) {
    case documentTypes.TEMPLATES: // Templates
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.TEMPLATES &&
          document.subcategory !== documentTypes.DOCUMENTS &&
          (document?.isCommon || document.society === actualSociety?._id)
      );
      break;

    case documentTypes.SCRIPTURES: // Escrituras
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.SCRIPTURES &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.MINUTEBOOK: // Libro de actas
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.MINUTEBOOK &&
          document?.subcategory === currentBook?._id &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.COUNCILMINUTES: // Actas Consejo
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.COUNCILMINUTES &&
          document?.subcategory === currentCouncilMinute?._id &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.CERTIFICATES: // Certificados
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.CERTIFICATES &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.LETTERS: // Cartas
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.LETTERS &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.SIGNATURES: // Firmas
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.SIGNATURES &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      // Filter the signed documents
      if (signatureDocumentCategory === 'SIGNED') {
        docs = docs?.filter(
          (document: Document) => document?.subcategory === 'SIGNED'
        );
      }
      // Filter the pending documents
      else if (signatureDocumentCategory === 'PENDING') {
        docs = docs?.filter(
          (document: Document) =>
            !document?.subcategory || document?.subcategory === 'PENDING'
        );
      }

      break;
    case documentTypes.ASSIGNMENTS: // Nombramientos
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.ASSIGNMENTS &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;
    case documentTypes.AUTHORITY: // Poderes
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.AUTHORITY &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.ANNUALREPORTS: // Cuentas Anuales
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.ANNUALREPORTS &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.MYFOLDERS: // Mis Carpetas
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.MYFOLDERS &&
          document?.subcategory === currentFolder?._id &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    case documentTypes.DELETED: // Deleted
      docs = documents?.filter(
        (document: Document) =>
          document?.category === documentTypes.DELETED &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;
    case documentTypes.DOCUMENTS: // Documents
      docs = documents?.filter(
        (document: Document) =>
          ((document.category === documentTypes.TEMPLATES &&
            document.subcategory === documentTypes.DOCUMENTS) ||
            document.category === documentTypes.DOCUMENTS) &&
          document.society === actualSociety?._id &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;

    default: // All
      docs = documents?.filter(
        (document: Document) =>
          ((document.category === documentTypes.TEMPLATES &&
            document.subcategory === documentTypes.DOCUMENTS) ||
            document?.category !== documentTypes.TEMPLATES) &&
          document?.category !== documentTypes.ALL &&
          document?.category !== documentTypes.DELETED &&
          document.society === actualSociety?._id &&
          (!document?.isForAdmins || (document?.isForAdmins && isAdmin))
      );
      break;
  }
  return docs;
};
